import React, { useState, useEffect, useRef, useCallback } from "react";

import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useForm, Controller, useWatch } from "react-hook-form";
import Grid from "@mui/material/Grid";
import Cookies from "universal-cookie";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import Divider from "@mui/material/Divider";
import {
  loadStates,
  loadCountiesList,
  loadProgramTypes,
} from "../../_redux/actions/userActions";
import { connect } from "react-redux";
import Paper from "@mui/material/Paper";
import { styled, useTheme } from "@mui/material/styles";
import PamV3 from "../../_images/PAMv3.png";
import Iid from "../../_images/L250.png";
import ISA from "../../_images/ISA.png";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import logo from "../../_images/logos/LogoLimited.png";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import SpeedIcon from "@mui/icons-material/Speed";
import HelpIcon from "@mui/icons-material/Help";
import { USA } from "@/_helpers/CountryConstants";
import { LifeSafer } from "../../_helpers/BrandConstants";
import PropTypes from "prop-types";
import { brandColors } from "../../_components/brandedComponent/BrandedColors";
import { utilities } from "@/_helpers";
// import { useDeviceTypeWatcher } from "@/_helpers/PhoneNumberHelper";

import {
  validateCode,
  clientProfiles,
} from "../../_redux/actions/enrolleeActions";
import ContinueButton from "./ContinueButton";

import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Dialog from "@mui/material/Dialog";
// import ClearIcon from "@mui/icons-material/Clear";
import { useParams } from "react-router-dom";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  textAlign: "left",
  height: 280,
  width: 320,
  minWidth: 320,
}));

const LOCATION_VIOLATION_DRAFT_KEY = "locationViolationDraft";

const ViolationInfo = ({
  loadStates,
  loadCountiesList,
  statesList,
  validateCode,
  handleUpdate,
  goToBackStep,
  submitting,
  setIsPam,
  clientProfiles,
  loadProgramTypes,
}) => {
  const cookies = new Cookies();
  const { storyName } = useParams();
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isBelow1400 = useMediaQuery(theme.breakpoints.down(1340));
  const enrolleeUser = JSON.parse(sessionStorage.getItem("enrolleeUser"));
  const url = window.location.href;

  const siteCountryId = cookies.get("siteCountry") || USA;
  const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;
  const enrollmentCodeData = cookies.get("lsEnrollmentCode");
  const [countiesList, setCountiesList] = useState([]);

  const [validatedCode, setValidatedCode] = useState(null);
  const [programTypes, setProgramTypes] = useState(null);
  const [deviceTypes, setDeviceTypes] = useState([]);
  const [deviceLoops, setDeviceLoops] = useState(null);

  const [selectedState, setSelectedState] = useState(null);
  const [convictionRegionId, setConvictionRegionId] = useState(null);
  const [selectedCounty, setSelectedCounty] = useState(null);
  const [selectedRequiredBy, setSelectedRequiredBy] = useState(null);

  const [openDrawer, setOpenDrawer] = useState(false);
  const [showHelpIcon, setShowHelpIcon] = useState(false);
  const [userData, setUserData] = useState(null);
  const isCountyFirstLoad = useRef(true);
  const isDeviceNeedFirstLoad = useRef(true);
  const [newEnrollmentCodeData, setNewEnrollmentCodeData] = useState(null);
  const isMobileSmall = useMediaQuery(theme.breakpoints.down("xs"));
  const jwtTokenData = cookies.get("lifesaferEnrollment");
  const programTypeData = cookies.get("EnrollNow");
  const [programList, setProgramList] = useState(null);
  const isLoadProgram = useRef(true);
  const isISA = url.includes("lifesaferisa");
  const isSpanish = (i18n?.language || "").toLowerCase().startsWith("es");
  const enrolleeUserId = enrolleeUser?.userId || enrolleeUser?.UserId;
  const isLocationStory = storyName?.toLowerCase() === "location";
  const isPartnerStory = storyName?.toLowerCase() === "partner";
  const isPartnerEnrollmentCodeType = (codeData = {}) =>
  
    (
      codeData?.enrollmentCodeType ??
      codeData?.EnrollmentCodeType ??
      codeData?.enrollmentcodeType
    )?.toLowerCase() === "partner";
  const isPartnerEnrollmentCode =
    isPartnerEnrollmentCodeType(enrollmentCodeData);
  const initialProtPlan = isLocationStory
    ? true
    : (enrolleeUser?.protPlan ?? enrolleeUser?.ProtPlan ?? true);
  const [, setDeviceNeeded] = useState(enrolleeUser?.clientTypeId || null);
  // const { isISA: IsaCheck } = useDeviceTypeWatcher();

  // console.log('ischeck',IsaCheck)

  const PROGRAM_TYPE_LABELS_ES = {
    "Administrative Order": "Orden Administrativa",
    "Court Order": "Mandato Judicial",
    Voluntary: "Voluntario",
    Commercial: "Comercial",
    "MDDP (Illinois Only)": "MDDP (Solo Illinois)",
    "Pre-Trial (Texas Only)": "Previo al Juicio (Solo Texas)",
    "Probation (Texas Only)": "Libertad Condicional (Solo Texas)",
    "HBAC (Michigan Only)": "HBAC (Solo Michigan)",
    "MDOS (Michigan Only)": "MDOS (Solo Michigan)",
    "Sobriety Court (Michigan Only)": "Corte de Sobriedad (Solo Michigan)",
    "Deferred Prosecution": "Enjuiciamiento Diferido",
    Other: "Otro",
    Bail: "Fianza",
    Bond: "Garantía",
    "I1 - Stream C (1 Year)": "I1 - Stream C (1 año)",
    "I3 - Stream C (3 Year)": "I3 - Stream C (3 años)",
    "IA - Stream C (6 mo.)": "IA - Stream C (6 meses)",
    "IP - Stream A (9 mo. min.)": "IP - Stream A (9 meses mín.)",
    "IS - Stream B (12 mo. min.)": "IS - Stream B (12 meses mín.)",
    "IL - Stream C (Lifetime)": "IL - Stream C (De por vida)",
    CD: "CD",
    Probation: "Libertad Condicional",
    "Impound/DA": "Incautación/DA",
    DMV: "DMV",
    U21: "U21",
    "Diversion (Oregon Only)": "Desviación (Solo Oregón)",
    "Not Diversion (Oregon Only)": "Sin Desviación (Solo Oregón)",
    "IQ - Stream D (18 mo. min.)": "IQ - Stream D (18 meses mín.)",
    "I6 - Stream C (6 y. min.)": "I6 - Stream C (6 años mín.)",
    "KY Interlock Program": "Programa de Interlock de KY",
    "TASC (New York Only)": "TASC (Solo Nueva York)",
    "Pre-Trial": "Previo al Juicio",
    "Parole (Texas Only)": "Libertad bajo palabra (Solo Texas)",
    Freight: "Carga",
    Passenger: "Pasajero",
    Demo: "Demostración",
    "Pre-Conviction": "Antes de la Condena",
  };

  const normalizeDeviceTypeOption = (deviceType) => {
    const normalizedDeviceType = String(deviceType || "")
      .trim()
      .toLowerCase();

    if (["iid", "interlock"].includes(normalizedDeviceType)) return "Interlock";
    if (["pam", "portable"].includes(normalizedDeviceType)) return "Portable";
    if (["isa", "speed", "speedv"].includes(normalizedDeviceType)) return "Speed";
    return null;
  };

  const getProgramTypeLabel = (programType) => {
    if (!programType) return "";
    if (!isSpanish) return programType;
    return PROGRAM_TYPE_LABELS_ES[programType] || programType;
  };

  const [selectedOptIn, setSelectedOptIn] = useState(initialProtPlan);
  const [sessionViolationDraft, setSessionViolationDraft] = useState(() => {
    try {
      const rawDraft = sessionStorage.getItem(LOCATION_VIOLATION_DRAFT_KEY);
      if (!rawDraft) return null;
      return JSON.parse(rawDraft);
    } catch (error) {
      console.error("Failed to parse location violation draft", error);
      return null;
    }
  });
  const hasAppliedSessionViolationDraftRef = useRef(false);
  const [openLosModal, setOpenLosModal] = useState(false);
  const [pendingApiCount, setPendingApiCount] = useState(0);

  const enrollNow = cookies.get("EnrollNow") || {};
  const showLpp = enrollNow?.ShowLPP || false;

  const DEVICE_TYPE_MAP = {
    Interlock: t("steps.iid"),
    Portable: t("steps.pam"),
    Speed: t("steps.isa"),
    ISA: t("steps.isa"),
  };

  const trackApiCall = useCallback(async (request) => {
    setPendingApiCount((count) => count + 1);
    try {
      return await request();
    } finally {
      setPendingApiCount((count) => Math.max(0, count - 1));
    }
  }, []);

  const isWhatIsThisDisabled = submitting || pendingApiCount > 0;

  const syncLocationProfileSession = useCallback(
    (profiles) => {
      const profileList = Array.isArray(profiles) ? profiles : [];
      if (!isLocationStory || profileList.length === 0) return profileList;

      try {
        const latestEnrollee =
          JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
        const convictionStateId =
          latestEnrollee?.ConvictionStateID ??
          latestEnrollee?.convictionStateID;
        const convictionCountyId =
          latestEnrollee?.ConvictionCountyID ??
          latestEnrollee?.convictionCountyID;
        const clientTypeId =
          latestEnrollee?.clientTypeId ??
          latestEnrollee?.ClientTypeId ??
          latestEnrollee?.clientTypeID ??
          latestEnrollee?.ClientTypeID;

        const syncedProfiles = profileList.map((profile, index) =>
          index === 0
            ? {
                ...profile,
                ...(convictionStateId !== undefined && {
                  convStateRegionID: convictionStateId,
                }),
                ...(convictionCountyId !== undefined && {
                  convCountyRegionID: convictionCountyId,
                }),
                ...(latestEnrollee?.programType !== undefined && {
                  programType: latestEnrollee.programType,
                }),
                ...(latestEnrollee?.contractEnd !== undefined && {
                  contractEnd: latestEnrollee.contractEnd,
                }),
                ...(latestEnrollee?.protPlan !== undefined && {
                  protPlan: latestEnrollee.protPlan,
                }),
                ...(clientTypeId !== undefined && {
                  clientTypeId,
                  clientTypeID: clientTypeId,
                }),
              }
            : profile,
        );

        sessionStorage.setItem(
          "clientProfiles",
          JSON.stringify(syncedProfiles),
        );
        return syncedProfiles;
      } catch (error) {
        console.error("Failed to sync client profile session", error);
        return profileList;
      }
    },
    [isLocationStory],
  );

  useEffect(() => {
    if (
      (enrolleeUser?.clientId || enrolleeUser?.ClientId) &&
      (enrolleeUser?.jwtToken ||
        jwtTokenData?.jwtToken ||
        enrolleeUser?.JwtToken)
    ) {
      trackApiCall(() =>
        clientProfiles(enrolleeUser?.clientId || enrolleeUser?.ClientId),
      )
        .then((x) => {
          const syncedProfiles = syncLocationProfileSession(x);
          setUserData(syncedProfiles);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [trackApiCall, syncLocationProfileSession]);

  useEffect(() => {
    setConvictionRegionId(enrollmentCodeData?.convictionRegionID ?? null);
  }, [enrollmentCodeData?.convictionRegionID]);

  useEffect(() => {
    const sessionConvictionStateId =
      enrolleeUser?.ConvictionStateID ?? enrolleeUser?.convictionStateID;
    const shouldUseEnrollmentCodeData =
      !utilities.isMissingOrDefaultEnrollmentCode(enrollmentCodeData) &&
      userData?.[0]?.convStateRegionID === 0;

    if (sessionConvictionStateId) {
      const matchedState = statesList.find(
        (x) => x.regionID === sessionConvictionStateId,
      );

      if (matchedState) {
        setValue("state", matchedState);
        setSelectedState(matchedState);
        clearErrors("state");
      }
    } else if (shouldUseEnrollmentCodeData) {
      if (convictionRegionId) {
        let matchedState = statesList.find(
          (x) => x.regionID === convictionRegionId,
        );

        if (matchedState) {
          setValue("state", matchedState);
          setSelectedState(matchedState);
          clearErrors("state");

          let newCookieData = {
            ...enrollmentCodeData,
            matchedStateName: matchedState?.name,
          };

          cookies.set("lsEnrollmentCode", newCookieData, {
            path: "/",
          });
        }
      }
      let matchProgramLength = programLength.find(
        (x) => enrollmentCodeData?.contractEnd?.toString() === x.label,
      );
      if (matchProgramLength) {
        setValue("deviceDuration", matchProgramLength);
        clearErrors("deviceDuration");
      }
    } else if (userData?.[0]) {
      if (userData[0]?.convStateRegionID) {
        let matchedState = statesList.find(
          (x) => x.regionID === userData[0]?.convStateRegionID,
        );

        if (matchedState) {
          setValue("state", matchedState);
          setSelectedState(matchedState);
          clearErrors("state");

          let newCookieData = {
            ...enrollmentCodeData,
            matchedStateName: matchedState?.name,
          };

          cookies.set("lsEnrollmentCode", newCookieData, {
            path: "/",
          });
        }
      }

      let matchProgramLength = programLength.find(
        (x) => userData[0]?.contractEnd?.toString() === x.label,
      );
      if (matchProgramLength) {
        setValue("deviceDuration", matchProgramLength);
        clearErrors("deviceDuration");
      }
    }
  }, [userData, statesList]);

  useEffect(() => {
    const sessionConvictionCountyId =
      enrolleeUser?.ConvictionCountyID ?? enrolleeUser?.convictionCountyID;
    const resolvedConvictionCountyId =
      sessionConvictionCountyId || userData?.[0]?.convCountyRegionID;

    if (
      isCountyFirstLoad.current === true &&
      resolvedConvictionCountyId &&
      countiesList?.length
    ) {
      const matchedCounty = countiesList.find(
        (x) => String(x.regionID) === String(resolvedConvictionCountyId),
      );

      if (!matchedCounty) return;

      setValue("county", matchedCounty);
      setSelectedCounty(matchedCounty);
      clearErrors("county");

      const resolvedProgramType =
        enrolleeUser?.programType || userData?.[0]?.programType;
      if (resolvedProgramType) {
        setValue("requiredBy", resolvedProgramType);
        setSelectedRequiredBy(resolvedProgramType);
        clearErrors("requiredBy");
      }

      isCountyFirstLoad.current = false;
    }
  }, [countiesList, userData]);

  useEffect(() => {
    if (userData && userData[0]?.programType && !getValues("requiredBy")) {
      setValue("requiredBy", userData[0]?.programType);
      setSelectedRequiredBy(userData[0]?.programType);
      clearErrors("requiredBy");
    }
  }, [userData, setValue, clearErrors, getValues]);

  let deviceLoopData = [
    {
      id: 1,
      title: t("steps.iid"),
      icon: <DirectionsCarIcon color="primary" />,
      description: t("steps.iidDescription"),
      type: "Interlock",
      image: Iid,
    },

    {
      id: 3,
      title: t("steps.isa"),
      icon: <SpeedIcon color="primary" />,
      description: t("steps.isaDescription"),
      type: "Speed",
      image: ISA,
    },

    {
      id: 2,
      title: t("steps.pam"),
      icon: <DirectionsCarIcon color="primary" />,
      description: t("steps.pamDescription"),
      type: "Portable",
      image: PamV3,
    },
  ];

  useEffect(() => {
    trackApiCall(() => loadStates(siteCountryId, brand)).catch((error) => {
      console.error("Error loading states", error);
    });
  }, [siteCountryId, brand, trackApiCall]);

  useEffect(() => {
    if (selectedState) {
      let isCurrentRequest = true;

      trackApiCall(() => loadCountiesList(selectedState?.regionID))
        .then((x) => {
          if (isCurrentRequest) {
            setCountiesList(Array.isArray(x) ? x : []);
          }
        })
        .catch((error) => {
          console.error("Error loading counties", error);
        });

      return () => {
        isCurrentRequest = false;
      };
    }
  }, [selectedState, trackApiCall]);

  useEffect(() => {
    if (selectedCounty) {
      trackApiCall(() => validateCode(selectedCounty?.enrollmentCode, brand))
        .then((x) => {
          setValidatedCode(x);

          if (x?.enrollmentCodeId && !isPartnerEnrollmentCode) {
            cookies.set("lsEnrollmentCode", x, {
              path: "/",
              sameSite: "strict",
            });

            // Keep the validated code and its ID together. The cookie value read
            // during the initial render may still contain the default code ID.
            setNewEnrollmentCodeData(x);
          }

          // may be used later
          // if (enrollmentCodeData?.enrollmentCode === "LIFESAFERDEFAULT") {
          //   let enrollmentCodeUpdate = {
          //     enrollmentCodeId: x?.enrollmentCodeId,
          //     enrollmentCode: x?.enrollmentCode,
          //   };
          //   sessionStorage.setItem(
          //     "enrolleeUser",
          //     JSON.stringify({ ...enrolleeUser, ...enrollmentCodeUpdate })
          //   );

          //   cookies.set(
          //     "lsEnrollmentCode",
          //     { ...enrollmentCodeData, ...enrollmentCodeUpdate },
          //     {
          //       path: "/",
          //       sameSite: "strict",
          //       expires: moment().add(2, "minutes").toDate(),
          //     }
          //   );
          // }
        })
        .catch((error) => {
          console.error("Error validating code", error);
        });
    }
  }, [selectedCounty, trackApiCall]);
  useEffect(() => {
    if (
      !enrolleeUserId ||
      !selectedState ||
      !programTypeData ||
      !isLoadProgram.current
    )
      return;

    trackApiCall(() => loadProgramTypes(selectedState?.name, enrolleeUserId))
      .then((res) => {
        setProgramList(res?.split(","));
      })
      .catch((error) => {
        console.error("Error loading counties", error);
      });
    isLoadProgram.current = true;
  }, [selectedState, programTypeData?.CellPhone, trackApiCall, enrolleeUserId]);

  const didPrefillRequiredBy = useRef(false);

  useEffect(() => {
    if (!validatedCode || didPrefillRequiredBy.current) return;

    if (validatedCode.programTypes) {
      const programTypesArray = validatedCode.programTypes.split(",");
      // setProgramTypes(programTypesArray);

      const filteredProgram = utilities?.programTypeFilter(
        programTypeData?.ProgramType,
      );

      if (
        filteredProgram?.programType &&
        (programList?.length > 0 || programTypesArray?.length > 0)
      ) {
        let programCookie =
          programTypesArray?.find(
            (p) =>
              p?.toLowerCase() === filteredProgram?.programType?.toLowerCase(),
          ) ||
          programList?.find(
            (p) =>
              p?.toLowerCase() === filteredProgram?.programType?.toLowerCase(),
          );
        if (
          programCookie &&
          getValues("requiredBy") !== programCookie &&
          !(Array.isArray(userData) && userData[0]?.programType)
        ) {
          setValue("requiredBy", programCookie);
          setSelectedRequiredBy(programCookie);
          didPrefillRequiredBy.current = true;
        }
      }
    } else {
      setProgramTypes([]);
    }
  }, [validatedCode, programList]);

  useEffect(() => {
    if (validatedCode && validatedCode?.programTypes) {
      setProgramTypes(validatedCode.programTypes.split(","));
    } else {
      setProgramTypes([]);
    }
  }, [validatedCode]);

  // useEffect(() => {
  //   if (validatedCode?.deviceTypes && selectedRequiredBy) {
  //     const deviceTypesArray = validatedCode?.deviceTypes.split(",");
  //     const hasSpeedOrIsa = deviceTypesArray.some((device) =>
  //       ["speed", "isa"].includes(device.toLowerCase())
  //     );
  //     if (!hasSpeedOrIsa && selectedRequiredBy === "Voluntary") {
  //       deviceTypesArray.push("Speed");
  //     }

  //     setDeviceTypes(deviceTypesArray);

  //     if (deviceTypesArray.length === 1) {
  //       setValue("deviceNeeded", deviceTypesArray[0]);
  //       clearErrors("deviceNeeded");
  //     }

  //     if (deviceTypesArray.length) {
  //       const filteredDeviceLoop = deviceLoopData.filter((x) => {
  //         if (
  //           selectedRequiredBy == "Voluntary" &&
  //           (x?.type?.toLowerCase() == "speed" ||
  //             x?.type?.toLowerCase() == "isa")
  //         ) {
  //           return true;
  //         }
  //         return deviceTypesArray.some(
  //           (device) => x.type.toLowerCase() === device.toLowerCase()
  //         );
  //       });
  //       setShowHelpIcon(true);
  //       setDeviceLoops(filteredDeviceLoop);
  //     }
  //   }
  //   if (
  //     enrolleeUser?.clientTypeId &&
  //     isDeviceNeedFirstLoad.current === true &&
  //     selectedRequiredBy
  //   ) {
  //     let prefillDeviceType =
  //       enrolleeUser?.clientTypeId === 6
  //         ? "Speed"
  //         : enrolleeUser?.clientTypeId === 5
  //         ? "Portable"
  //         : "Interlock";
  //     setValue("deviceNeeded", prefillDeviceType);
  //       clearErrors("deviceNeeded");

  //     isDeviceNeedFirstLoad.current = false;
  //   }
  // }, [selectedRequiredBy, validatedCode,i18n?.language]);

  useEffect(() => {
    if (!validatedCode) return;

    const deviceTypesRaw = validatedCode?.deviceTypes;

    if (!deviceTypesRaw && !isISA) return;

    let deviceTypesArray =
      deviceTypesRaw
        ?.split(",")
        .map(normalizeDeviceTypeOption)
        .filter(Boolean) || [];
    // if (isISA) {
    // } else {
    const hasSpeedOrIsa = deviceTypesArray.some((device) =>
      ["speed", "isa"].includes(device.toLowerCase()),
    );

    if (isISA) {
      deviceTypesArray = ["Speed"];
      setValue("deviceNeeded", "Speed");
      clearErrors("deviceNeeded");
    } else {
      if (isISA && hasSpeedOrIsa) {
        deviceTypesArray = ["Speed"];
        setValue("deviceNeeded", "Speed");
        clearErrors("deviceNeeded");
      }
    }
    // }

    setDeviceTypes(deviceTypesArray);

    if (deviceTypesArray.length === 1 && !sessionViolationDraft?.deviceType) {
      setValue("deviceNeeded", deviceTypesArray[0]);
      clearErrors("deviceNeeded");
    }

    const filteredDeviceLoop = deviceLoopData.filter((x) =>
      deviceTypesArray.some(
        (device) => x.type.toLowerCase() === device.toLowerCase(),
      ),
    );
    setDeviceLoops(filteredDeviceLoop);
    setShowHelpIcon(true);

    if (
      !sessionViolationDraft?.deviceType &&
      isDeviceNeedFirstLoad.current &&
      (deviceTypesArray.length > 0 || isISA)
    ) {
      let prefillDeviceType;

      if (isISA) {
        prefillDeviceType = "Speed";
      } else if (
        resolvedEnrolleeClientTypeId ||
        enrolleeUser?.deviceType ||
        enrolleeUser?.DeviceType
      ) {
        const normalizedSessionDeviceType = (
          enrolleeUser?.deviceType ||
          enrolleeUser?.DeviceType ||
          ""
        ).toLowerCase();
        prefillDeviceType =
          (resolvedEnrolleeClientTypeId === 6 ||
            normalizedSessionDeviceType === "speed") &&
          hasSpeedOrIsa
            ? "Speed"
            : resolvedEnrolleeClientTypeId === 5 ||
                ["portable", "pam"].includes(normalizedSessionDeviceType)
              ? "Portable"
              : "Interlock";
      }

      const matchedDeviceType = deviceTypesArray.find(
        (deviceType) =>
          prefillDeviceType &&
          deviceType.toLowerCase() === prefillDeviceType.toLowerCase(),
      );

      if (matchedDeviceType) {
        setValue("deviceNeeded", matchedDeviceType);
        clearErrors("deviceNeeded");
        isDeviceNeedFirstLoad.current = false;
      }
    }
  }, [
    validatedCode,
    i18n?.language,
    isISA,
    selectedCounty,
    isCountyFirstLoad.current,
    sessionViolationDraft,
  ]);

  const { handleSubmit, control, setValue, clearErrors, getValues } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      state: null,
      county: null,
      requiredBy: null,
      deviceNeeded: null,
      protPlan: null,
      deviceDuration: {
        id: 4,
        label: "6",
      },
    },
  });

  const watchedDeviceNeeded = useWatch({
    control,
    name: "deviceNeeded",
  });

  const isSpeedDeviceType = (value) =>
    value === 6 || ["speed", "isa"].includes((value || "").toLowerCase());

  useEffect(() => {
    setDeviceNeeded(watchedDeviceNeeded || null);
  }, [watchedDeviceNeeded]);

  useEffect(() => {
    if (!watchedDeviceNeeded) {
      setProgramTypes([]);
      return;
    }

    const allProgramTypes = validatedCode?.programTypes?.split(",") ?? [];
    const nextProgramTypes =
      storyName?.toLowerCase() !== "speed" &&
      isSpeedDeviceType(watchedDeviceNeeded)
        ? allProgramTypes.filter((programType) => programType !== "Voluntary")
        : allProgramTypes;

    setProgramTypes(nextProgramTypes);

    if (!nextProgramTypes.includes(getValues("requiredBy"))) {
      setValue("requiredBy", null);
      setSelectedRequiredBy(null);
    }
  }, [validatedCode, watchedDeviceNeeded, storyName, setValue, getValues]);

  useEffect(() => {
    if (typeof setIsPam === "function") {
      setIsPam(isPamDeviceType(watchedDeviceNeeded));
    }
  }, [watchedDeviceNeeded, setIsPam]);

  useEffect(() => {
    if (
      storyName?.toLowerCase() !== "speed" &&
      isSpeedDeviceType(watchedDeviceNeeded) &&
      selectedRequiredBy === "Voluntary"
    ) {
      setValue("requiredBy", null);
      setSelectedRequiredBy(null);
    }
  }, [watchedDeviceNeeded, selectedRequiredBy, setValue, storyName]);

  const onSubmit = (data) => {
    let oldData = {
      EnrolleeId: enrolleeUser?.enrolleeId || enrolleeUser?.EnrolleeId,
      ClientId: enrolleeUser?.clientId || enrolleeUser?.ClientId,
      UserId: enrolleeUser?.userId || enrolleeUser?.UserId,
      firstName: enrolleeUser?.firstName || enrolleeUser?.FirstName,
      lastName: enrolleeUser?.lastName || enrolleeUser?.LastName,
      dob: enrolleeUser?.dob || enrolleeUser?.Dob,
      homeAddr1: enrolleeUser?.homeAddr1 || enrolleeUser?.HomeAddr1,
      homeAddr2: enrolleeUser?.homeAddr2 || enrolleeUser?.HomeAddr2,
      city: enrolleeUser?.city || enrolleeUser?.City,
      zip: enrolleeUser?.zip || enrolleeUser?.Zip,
      state: enrolleeUser?.state || enrolleeUser?.State,
      county: (enrolleeUser?.county || enrolleeUser?.County || "").replace(
        /['"]/g,
        "",
      ),
      country: enrolleeUser?.country || enrolleeUser?.Country,
      // homeLat: enrolleeUser?.firstName,
      // homeLong: enrolleeUser?.firstName,
      dlState: enrolleeUser?.dlState || enrolleeUser?.DlState || null,
      dlNum: enrolleeUser?.dlNum || enrolleeUser?.DlNum || "CE - NEED",
      dlExpirationDate:
        enrolleeUser?.dlExpirationDate || enrolleeUser?.DlExpirationDate,
      email: enrolleeUser?.email || enrolleeUser?.Email,
      homePhone: enrolleeUser?.homePhone || enrolleeUser?.HomePhone,
      cellPhone: enrolleeUser?.cellPhone || enrolleeUser?.CellPhone,
      workPhone: enrolleeUser?.workPhone || enrolleeUser?.WorkPhone,
      programType: enrolleeUser?.programType || enrolleeUser?.ProgramType,
      protPlan: enrolleeUser?.protPlan || enrolleeUser?.ProtPlan,
      contractEnd: enrolleeUser?.contractEnd || enrolleeUser?.ContractEnd,
      // portalID: enrolleeUser?.firstName,
      // preferredContactId: enrolleeUser?.firstName,
    };

    // let deviceNeededData =
    //   data?.deviceNeeded?.toLowerCase() === "portable"
    //     ? "PAM"
    //     : data?.deviceNeeded?.toLowerCase() === "speed" ||
    //       data?.deviceNeeded?.toLowerCase() === "isa"
    //     ? "SPEED"
    //     : "IID";

    let newData = {
      Step: "Violation",
      story: isPartnerEnrollmentCode ? "Partner" : "Pricing",
      ConvictionStateID: data.state.regionID,
      ConvictionCountyID: data.county.regionID,
      deviceType: data?.deviceNeeded,
      contractEnd: data?.deviceDuration?.label,
      programType: data?.requiredBy,
      protPlan: selectedOptIn,
    };
    let updatedData = {
      ...oldData,
      ...newData,
    };

    if (data.state.regionID) {
      const matchedState = statesList.find(
        (stateItem) => stateItem?.regionID === data.state.regionID,
      );

      const latestEnrollmentCodeData =
        newEnrollmentCodeData ||
        cookies.get("lsEnrollmentCode") ||
        enrollmentCodeData ||
        {};

      let newCookieData = {
        ...latestEnrollmentCodeData,
        matchedStateName: matchedState?.name,
      };

      cookies.set("lsEnrollmentCode", newCookieData, {
        path: "/",
      });
    }

    if (isPartnerEnrollmentCode) {
      handleUpdate("Violation", updatedData);
      return;
    }

    const currentEnrollmentCodeData =
      cookies.get("lsEnrollmentCode") || enrollmentCodeData || {};

    const validatedEnrollmentCodeData =
      validatedCode?.enrollmentCodeId
        ? validatedCode
        : newEnrollmentCodeData?.enrollmentCodeId
          ? newEnrollmentCodeData
          : null;
    const resolvedEnrollmentCodeData =
      validatedEnrollmentCodeData || currentEnrollmentCodeData;

    updatedData = {
      ...updatedData,
      enrollmentCodeId: resolvedEnrollmentCodeData?.enrollmentCodeId,
      enrollmentCode: resolvedEnrollmentCodeData?.enrollmentCode,
    };
    handleUpdate("Violation", updatedData);
  };

  const programLength = [
    {
      id: 1,
      label: "3",
    },
    {
      id: 2,
      label: "4",
    },
    {
      id: 3,
      label: "5",
    },
    {
      id: 4,
      label: "6",
    },
    {
      id: 5,
      label: "7",
    },
    {
      id: 6,
      label: "8",
    },
    {
      id: 7,
      label: "9",
    },
    {
      id: 8,
      label: "10",
    },
    {
      id: 9,
      label: "11",
    },
    {
      id: 10,
      label: "12",
    },
    {
      id: 11,
      label: "15",
    },
    {
      id: 12,
      label: "18",
    },
    {
      id: 13,
      label: "24",
    },
  ];

  const displayDeviceTypeName = (name) => DEVICE_TYPE_MAP[name] || name;

  const resolvedEnrolleeClientTypeId =
    enrolleeUser?.clientTypeId ??
    enrolleeUser?.ClientTypeId ??
    enrolleeUser?.clientTypeID ??
    enrolleeUser?.ClientTypeID;

  const isPamDeviceType = (value) =>
    ["portable", "pam"].includes((value || "").toLowerCase()) ||
    (!value && resolvedEnrolleeClientTypeId === 5);

  useEffect(() => {
    if (!sessionViolationDraft || hasAppliedSessionViolationDraftRef.current) {
      return;
    }

    const draftStateId = sessionViolationDraft?.ConvictionStateID;
    const draftCountyId = sessionViolationDraft?.ConvictionCountyID;
    const normalizedDraftDeviceType =
      (sessionViolationDraft?.deviceType || "").toLowerCase() === "pam"
        ? "Portable"
        : sessionViolationDraft?.deviceType;
    const requiredDraftCounty = Boolean(draftCountyId);

    if (
      (!getValues("state") || !getValues("state")?.regionID) &&
      draftStateId &&
      statesList?.length
    ) {
      const matchedState = statesList.find(
        (stateItem) => stateItem?.regionID === draftStateId,
      );
      if (matchedState) {
        setValue("state", matchedState);
        setSelectedState(matchedState);
        clearErrors("state");
      }
    }

    if (requiredDraftCounty && !countiesList?.length) {
      return;
    }

    if (requiredDraftCounty) {
      const matchedCounty = countiesList.find(
        (countyItem) => countyItem?.regionID === draftCountyId,
      );
      if (!matchedCounty) {
        return;
      }

      if (!getValues("county")) {
        setValue("county", matchedCounty);
        setSelectedCounty(matchedCounty);
        clearErrors("county");
      }
    }

    if (normalizedDraftDeviceType) {
      setValue("deviceNeeded", normalizedDraftDeviceType);
      clearErrors("deviceNeeded");
    }

    if (!getValues("requiredBy") && sessionViolationDraft?.programType) {
      setValue("requiredBy", sessionViolationDraft?.programType);
      setSelectedRequiredBy(sessionViolationDraft?.programType);
      clearErrors("requiredBy");
    }

    if (sessionViolationDraft?.contractEnd) {
      const matchedDuration = programLength.find(
        (durationItem) =>
          String(durationItem?.label) ===
          String(sessionViolationDraft?.contractEnd),
      );
      if (matchedDuration) {
        setValue("deviceDuration", matchedDuration);
        clearErrors("deviceDuration");
      }
    }

    if (typeof sessionViolationDraft?.protPlan === "boolean") {
      setSelectedOptIn(sessionViolationDraft.protPlan);
    }

    hasAppliedSessionViolationDraftRef.current = true;
    setSessionViolationDraft(null);
  }, [
    sessionViolationDraft,
    statesList,
    countiesList,
    setValue,
    clearErrors,
    getValues,
  ]);

  const toggleDrawer = (newOpen) => () => {
    setOpenDrawer(newOpen);
  };

  const changeDeviceNeeded = (deviceNeeded) => {
    if (isSpeedDeviceType(deviceNeeded) && selectedRequiredBy === "Voluntary") {
      setValue("requiredBy", null);
      setSelectedRequiredBy(null);
    }

    setValue("deviceNeeded", deviceNeeded);
    clearErrors("deviceNeeded");
    if (typeof setIsPam === "function") {
      setIsPam(isPamDeviceType(deviceNeeded));
    }
    setOpenDrawer(false);
  };

  const handleClose = () => {
    setOpenLosModal(false);
  };

  const handleOpenLosModal = () => {
    if (isWhatIsThisDisabled) return;
    setOpenLosModal(true);
  };

  const LossProtectionPlanModel = () => {
    return (
      <Dialog
        open={openLosModal}
        disableEnforceFocus
        onClose={handleClose}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
        sx={{ display: "flex", justifyContent: "center" }}
        slotProps={{
          backdrop: {
            sx: {
              // backdropFilter: "blur(8px)",
              // backgroundColor: "#CCCCCC",
            },
          },
        }}
      >
        <DialogTitle
          sx={{
            // backgroundColor: `${brandColors[brand].secondary}`,
            fontWeight: "bold",
            color: "black",
            paddingBottom: "8px !important",
          }}
        >
          {/* <ClearIcon
            sx={{
              float: "right",
              backgroundColor: "#D9D9D9",
              color: "black",
              borderRadius: "50%",
              padding: "4px",
            }}
            onClick={handleClose}
          /> */}

          {/* {t("steps.talkExperts")} */}
          <Typography sx={{ fontWeight: "bold" }}>
            {t("location.lossProtectionTitle")}
          </Typography>
        </DialogTitle>

        <DialogContent
          sx={{
            overflow: "hidden",

            width: {
              xs: isSpanish ? "100%" : "100%", // small screens (mobile)
              sm: isSpanish ? "420px" : "320px", // tablet
              md: isSpanish ? "420px" : "320px", // desktop
            },
            // height: {
            //   xs: "280px", // small screens (mobile)
            //   sm: "245px", // tablet
            //   md: "245px", // desktop
            // },
          }}
        >
          <Grid size={{ xs: 12 }}>
            <Typography sx={{ fontSize: "14px" }}>
              {t("location.lossProtectionDescription")}
            </Typography>
          </Grid>

          <Grid size={{ xs: 12 }} style={{ textAlign: "center", marginTop: 8 }}>
            <Box
              onClick={handleClose}
              sx={{
                display: "inline",
                cursor: "pointer",
                color: "#4b9CD3",
              }}
            >
              {t("location.exit")}
            </Box>
          </Grid>
        </DialogContent>
      </Dialog>
    );
  };

  const LossProtectionPlan = () => {
    return (
      <>
        <FormControlLabel
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: 1,
            marginLeft: "0px !important",
            // marginRight: "6px !important",
          }}
          control={
            <Checkbox
              checked={selectedOptIn}
              onChange={(e) => setSelectedOptIn(e.target.checked)}
              sx={{
                p: 0,
                color: "#499ED8 !important",
                // marginBottom:"20px",
              }}
              disabled={submitting || isWhatIsThisDisabled}
            />
          }
          label={
            <Grid>
              <Typography
                sx={{
                  lineHeight: "22px",
                  width: selectedOptIn ? "120%" : "100%",
                }}
              >
                {selectedOptIn
                  ? t("location.stateOpt1")
                  : t("location.stateOpt2")}
              </Typography>

              <Typography
                sx={{
                  fontSize: "15px",
                  color: isWhatIsThisDisabled ? "textDisabled" : "#499ED8",
                  textDecoration: "underline",
                  cursor: "pointer",
                  pointerEvents: isWhatIsThisDisabled ? "none" : "visible",
                  userSelect: isWhatIsThisDisabled ? "none" : "text",
                  // marginLeft: "22px",
                  // background:"red",
                }}
                onClick={handleOpenLosModal}
              >
                {t("location.whatIsThis")}
              </Typography>
            </Grid>
          }
        />
      </>
    );
  };

  return (
    <div>
      {openLosModal && <LossProtectionPlanModel />}

      <form
        className="form"
        onSubmit={handleSubmit(onSubmit)}
        style={{
          width: "100%",
          marginBottom: "40px",
          display: "flex",
          justifyContent: "center",
          maxWidth: "900px",
        }}
      >
        <Grid
          container
          alignItems="start"
          justifyContent="center"
          // direction="column"
          sx={{
            // width: { xl: "80%", lg: "100%", md: "80%", sm: "100%" },
            width: "100%",
            marginTop: isLocationStory ? "25px" : "25px",
          }}
          spacing="25px"
        >
          <Grid style={{ maxWidth: "300px", width: "100%" }}>
            <Controller
              name="state"
              disableClearable
              render={({
                field: { onChange, value, ...fieldProps },
                fieldState: { error },
              }) => (
                <Autocomplete
                  {...fieldProps}
                  id="state"
                  options={statesList ?? []}
                  disableClearable
                  getOptionLabel={(option) => option?.name}
                  isOptionEqualToValue={(option, value) =>
                    value?.name === option?.name
                  }
                  disabled={submitting}
                  onChange={(_, data) => {
                    onChange(data);
                    setSelectedState(data);
                    setSelectedCounty(null);
                    setSelectedRequiredBy(null);
                    setValue("county", null);
                    setValue("requiredBy", null);
                    setValue("deviceNeeded", null);
                    setShowHelpIcon(false);
                    setDeviceTypes(null);
                    setValidatedCode(null);
                  }}
                  value={value}
                  slotProps={{
                    clearIndicator: {
                      sx: { display: "none" },
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      fullWidth
                      {...params}
                      size="small"
                      label={
                        isPartnerStory
                          ? t("partner.offenseState")
                          : t("steps.violationState")
                      }
                      variant="outlined"
                      placeholder={t("body.statePlaceholder")}
                      error={!!error}
                      helperText={error?.message}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                />
              )}
              control={control}
              rules={{
                required: isPartnerStory
                  ? t("partner.offenseStateRequired")
                  : t("steps.violationStateRequired"),
              }}
            />
            {/* {
              isPartnerStory && (

            <Grid sx={{width:"100%",display:"flex",justifyContent:"center"}}>
              <Typography sx={{fontSize:"12px",width:"90%",color:"#666666",marginTop:"4px"}}>
                {t("partner.offenseStateDescription")}
              </Typography>
            </Grid>
              )} */}
          </Grid>
          <Grid style={{ maxWidth: "300px", width: "100%" }}>
            <Controller
              disableClearable
              name="county"
              render={({
                field: { onChange, value, ...fieldProps },
                fieldState: { error },
              }) => (
                <Autocomplete
                  {...fieldProps}
                  id="county"
                  options={countiesList ?? []}
                  disableClearable
                  getOptionLabel={(option) => option?.countyName}
                  isOptionEqualToValue={(option, value) =>
                    value?.countyName === option?.countyName
                  }
                  onChange={(_, data) => {
                    onChange(data);
                    setSelectedCounty(data);

                    setSelectedRequiredBy(null);
                    // setSelectedDeviceNeeded(null);
                    setValue("requiredBy", null);
                    setValue("deviceNeeded", null);
                    setShowHelpIcon(false);
                    setDeviceTypes(null);
                    setProgramTypes([]);
                  }}
                  value={value}
                  slotProps={{
                    clearIndicator: {
                      sx: { display: "none" },
                    },
                  }}
                  disabled={!selectedState || submitting}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      size="small"
                      label={
                        isPartnerStory
                          ? t("partner.offenseCounty")
                          : t("steps.violationCounty")
                      }
                      variant="outlined"
                      placeholder={t("body.countyPlaceholder")}
                      error={!!error}
                      helperText={error?.message}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                />
              )}
              control={control}
              rules={{
                required: isPartnerStory
                  ? t("partner.offenseCountyRequired")
                  : t("steps.violationCountyRequired"),
              }}
            />
          </Grid>

          <Grid style={{ maxWidth: "300px", width: "100%" }}>
            {isMobile &&
              showHelpIcon &&
              deviceTypes &&
              deviceTypes?.length > 1 && (
                <Grid
                  sx={{
                    background: "red",
                    width: "110%",
                    display: "flex",
                    justifyContent: "flex-end",
                    position: "relative",
                  }}
                >
                  <HelpIcon
                    color="primary"
                    sx={{
                      position: "absolute",
                      bottom: "2px",
                    }}
                    onClick={toggleDrawer(true)}
                  />
                </Grid>
              )}

            <Controller
              disableClearable
              name="deviceNeeded"
              render={({
                field: { onChange, value, ...fieldProps },
                fieldState: { error },
              }) => (
                <Autocomplete
                  {...fieldProps}
                  id="deviceNeeded"
                  options={deviceTypes ?? []}
                  disableClearable
                  getOptionLabel={(option) => displayDeviceTypeName(option)}
                  isOptionEqualToValue={(option, value) => value === option}
                  onChange={(_, data) => {
                    onChange(data);
                    setDeviceNeeded(data);
                    setValue("requiredBy", null);
                    setSelectedRequiredBy(null);
                    clearErrors("requiredBy");
                  }}
                  value={value}
                  slotProps={{
                    clearIndicator: {
                      sx: { display: "none" },
                    },
                  }}
                  disabled={submitting || !selectedCounty}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      size="small"
                      label={t("steps.deviceNeeded")}
                      variant="outlined"
                      placeholder={t("steps.deviceNeededPlaceholder")}
                      error={!!error}
                      helperText={error?.message}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                />
              )}
              control={control}
              rules={{
                required: t("steps.deviceNeededRequired"),
              }}
            />
          </Grid>

          <Grid style={{ maxWidth: "300px", width: "100%" }}>
            <Controller
              disableClearable
              name="requiredBy"
              render={({
                field: { onChange, value, ...fieldProps },
                fieldState: { error },
              }) => (
                <Autocomplete
                  {...fieldProps}
                  id="requiredBy"
                  options={programTypes ?? []}
                  disableClearable
                  getOptionLabel={(option) => getProgramTypeLabel(option)}
                  isOptionEqualToValue={(option, value) => value === option}
                  onChange={(_, data) => {
                    onChange(data);
                    setSelectedRequiredBy(data);
                  }}
                  value={value}
                  slotProps={{
                    clearIndicator: {
                      sx: { display: "none" },
                    },
                  }}
                  disabled={
                    !selectedCounty || !watchedDeviceNeeded || submitting
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      size="small"
                      label={t("steps.whoIsRequiringDevice")}
                      variant="outlined"
                      placeholder={t("steps.whoIsRequiringDevicePlaceholder")}
                      error={!!error}
                      helperText={error?.message}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                />
              )}
              control={control}
              rules={{
                required: t("steps.whoIsRequiringDeviceRequired"),
              }}
            />
          </Grid>

          {/* <Grid style={{ maxWidth: "300px", width: "100%" }}>
            {isMobile &&
              showHelpIcon &&
              deviceTypes &&
              deviceTypes?.length > 1 && (
                <Grid
                  sx={{
                    background: "red",
                    width: "110%",
                    display: "flex",
                    justifyContent: "flex-end",
                    position: "relative",
                  }}
                >
                  <HelpIcon
                    color="primary"
                    sx={{
                      position: "absolute",
                      bottom: "2px",
                    }}
                    onClick={toggleDrawer(true)}
                  />
                </Grid>
              )}

            <Controller
              disableClearable
              name="deviceNeeded"
              render={({
                field: { onChange, value, ...fieldProps },
                fieldState: { error },
              }) => (
                <Autocomplete
                  {...fieldProps}
                  id="deviceNeeded"
                  options={deviceTypes ?? []}
                  disableClearable
                  getOptionLabel={(option) => displayDeviceTypeName(option)}
                  isOptionEqualToValue={(option, value) => value === option}
                  onChange={(_, data) => {
                    onChange(data);
                    setDeviceNeeded(data);
                  }}
                  value={value}
                  slotProps={{
                    clearIndicator: {
                      sx: { display: "none" },
                    },
                  }}
                  disabled={
                    submitting ||
                    (isLocationStory && !selectedCounty) ||
                    (!isLocationStory && !selectedRequiredBy)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      size="small"
                      label={
                        isLocationStory
                          ? t("location.device")
                          : t("steps.deviceNeeded")
                      }
                      variant="outlined"
                      placeholder={t("steps.deviceNeededPlaceholder")}
                      error={!!error}
                      helperText={error?.message}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                />
              )}
              control={control}
              rules={{
                required: isLocationStory
                  ? t("steps.deviceRequired")
                  : t("steps.deviceNeededRequired"),
              }}
            />
          </Grid> */}
          <Grid style={{ maxWidth: "300px", width: "100%" }}>
            <Controller
              disableClearable
              name="deviceDuration"
              render={({
                field: { onChange, value, ...fieldProps },
                fieldState: { error },
              }) => (
                <Autocomplete
                  {...fieldProps}
                  id="deviceDuration"
                  options={programLength}
                  disableClearable
                  disabled={submitting}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option, value) =>
                    value?.label === option?.label
                  }
                  onChange={(_, data) => onChange(data)}
                  value={value}
                  slotProps={{
                    clearIndicator: {
                      sx: { display: "none" },
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      size="small"
                      label={
                        // isLocationStory
                        //   ? t("location.programLength")
                        // :
                        t("steps.deviceNeededQuestion")
                      }
                      variant="outlined"
                      // placeholder="Select a Device"
                      error={!!error}
                      helperText={error?.message}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {params.InputProps.endAdornment}{" "}
                            {/* {!isLocationStory && (
                              <>{t("body.deviceLengthMonths")}</>
                            )} */}
                            {t("body.deviceLengthMonths")}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              )}
              control={control}
              rules={{
                required:
                  // !isLocationStory
                  // ?
                  t("steps.deviceNeededQuestionRequired"),
                // : t("steps.programLengthRequired"),
              }}
            />
          </Grid>
          {(isLocationStory || showLpp) && (
            <Grid
              sx={{
                width: isMobile ? "100%" : "100%",
                maxWidth: isMobile ? "300px" : "300px",
              }}
            >
              <Grid
                sx={{
                  width: "100%",
                  maxWidth: isMobile ? "300px" : "100%",
                  // background: "pink",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Grid
                  sx={{
                    display: "flex",
                    // alignItems: "center",
                    flexDirection: "column",
                    // width: "100%",
                    // width: isMobile ? "100%" : "78%",
                    // marginLeft: isMobile ? "0px" : "12px",
                    border: !selectedOptIn ? "1px solid #d1495b" : "",
                    backgroundColor: !selectedOptIn
                      ? "rgba(209, 73, 91, 0.2)"
                      : "transparent",
                    // background: "red",
                    // justifyContent: "flex-start",
                  }}
                >
                  {/* <FormControlLabel
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1,
                    marginLeft: "0px !important",
                    // marginRight: "6px !important",
                  }}
                  control={
                    <Checkbox
                      checked={selectedOptIn}
                      onChange={(e) => setSelectedOptIn(e.target.checked)}
                      sx={{
                        p: 0,
                        color: "#499ED8 !important",
                        // marginBottom:"20px",
                      }}
                      disabled={submitting}
                    />
                  }
                  label={
                    <Grid>
                      <Typography
                        sx={{
                          lineHeight: "22px",
                          width:selectedOptIn  ? "120%" : "100%",
                        }}
                      >
                        {selectedOptIn
                          ? t("location.stateOpt1")
                          : t("location.stateOpt2")}
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: "15px",
                          color: submitting ? "textDisabled" : "#499ED8",
                          textDecoration: "underline",
                          cursor: "pointer",
                          pointerEvents: submitting ? "none" : "visible",
                          userSelect: submitting ? "none" : "text",
                          // marginLeft: "22px",
                          // background:"red",
                        }}
                        onClick={() => {
                          // e.stopPropagation();
                          setSelectedOptIn(!selectedOptIn);
                          setOpenLosModal(true);
                        }}
                      >
                        {t("location.whatIsThis")}
                      </Typography>
                    </Grid>
                  }
                /> */}

                  <LossProtectionPlan />
                </Grid>
              </Grid>
            </Grid>
          )}

          <ContinueButton
            goToBackStep={goToBackStep}
            // submitting={submitting || pendingApiCount > 0}
            submitting={submitting}
          />

          {!isMobile && (
            <Grid
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
              gap={4}
            >
              <div
                style={{
                  display: "flex",
                  gap: "25px",
                  justifyContent: "center",
                  flexWrap: isBelow1400 ? "wrap" : "nowrap",
                }}
              >
                {deviceTypes?.includes("Interlock") && (
                  <StyledPaper
                    elevation={2}
                    onClick={() => changeDeviceNeeded("Interlock")}
                    sx={{ cursor: "pointer" }}
                  >
                    <Grid container direction="column">
                      <Grid style={{ height: 36 }}>
                        <Grid container direction="row">
                          <Grid size={{ xs: 12 }}>
                            <Typography
                              variant="h6"
                              component="div"
                              sx={{
                                fontWeight: "bold",
                                color: `${brandColors[brand].primary}`,
                                fontSize: "18px",
                                textAlign: "center",
                                lineHeight: 1.2,
                              }}
                            >
                              {t("steps.iid")}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid style={{ marginTop: 8, display: "flex" }}>
                        <Grid
                          sx={{
                            width: "35%",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src={Iid}
                            style={{ height: "95%", width: "100%" }}
                          />
                        </Grid>

                        <Grid
                          sx={{
                            width: "65%",
                            fontSize: "14px",
                            textAlign: "center",
                            fontStyle: "italic",
                          }}
                        >
                          {t("steps.iidDescription")}
                        </Grid>
                      </Grid>
                    </Grid>
                  </StyledPaper>
                )}

                {deviceTypes?.includes("Portable") && (
                  <StyledPaper
                    elevation={2}
                    sx={{ cursor: "pointer" }}
                    onClick={() => changeDeviceNeeded("Portable")}
                  >
                    <Grid container direction="column">
                      <Grid style={{ height: 36 }}>
                        <Grid container direction="row">
                          <Grid size={{ xs: 12 }}>
                            <Typography
                              variant="h6"
                              component="div"
                              sx={{
                                fontWeight: "bold",
                                color: `${brandColors[brand].primary}`,
                                fontSize: "18px",
                                textAlign: "center",
                                lineHeight: 1.2,
                              }}
                            >
                              {t("steps.pam")}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid style={{ marginTop: 5, display: "flex" }}>
                        <Grid
                          sx={{
                            width: "40%",
                            marginTop: "16px",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={PamV3}
                            style={{ height: "67%", width: "92%" }}
                          />
                        </Grid>

                        <Grid
                          sx={{
                            width: "60%",
                            fontSize: "14px",
                            textAlign: "center",
                            marginTop: "15px",
                            fontStyle: "italic",
                          }}
                        >
                          {t("steps.pamDescription")}
                        </Grid>
                      </Grid>
                    </Grid>
                  </StyledPaper>
                )}

                {(deviceTypes?.includes("Speed") ||
                  deviceTypes?.includes("ISA")) && (
                  <StyledPaper
                    elevation={2}
                    sx={{ cursor: "pointer" }}
                    onClick={() => changeDeviceNeeded("Speed")}
                  >
                    <Grid container direction="column">
                      <Grid style={{ height: 36 }}>
                        <Grid container direction="row">
                          <Grid size={{ xs: 12 }}>
                            <Typography
                              variant="h6"
                              component="div"
                              sx={{
                                fontWeight: "bold",
                                color: `${brandColors[brand].primary}`,
                                fontSize: "17.5px",
                                textAlign: "center",
                                lineHeight: 1.2,
                              }}
                            >
                              {t("steps.isa")}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid style={{ marginTop: 5, display: "flex" }}>
                        <Grid
                          sx={{
                            width: "50%",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src={ISA}
                            style={{ height: "60%", width: "100%" }}
                          />
                        </Grid>

                        <Grid
                          sx={{
                            width: "50%",
                            fontSize: "14px",
                            textAlign: "center",
                            marginTop: "15px",
                            fontStyle: "italic",
                          }}
                        >
                          {t("steps.isaDescription")}
                        </Grid>
                      </Grid>
                    </Grid>
                  </StyledPaper>
                )}
              </div>
            </Grid>
          )}

          <Drawer
            anchor="bottom"
            open={openDrawer}
            onClose={toggleDrawer(false)}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                borderTop: "2px solid #1c355e",
              }}
            >
              <Box
                sx={{
                  width: "95%",
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  py: 1,
                }}
              >
                <Grid
                  sx={{ display: "flex", alignItems: "center", gap: "4px" }}
                >
                  <img
                    src={logo}
                    alt="logo"
                    style={{
                      height: isMobileSmall ? "26px" : "18px",
                      width: isMobileSmall ? "150px" : "100px",
                    }}
                  />
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: brandColors[brand].primary,
                      mt: isMobileSmall ? "8px" : "2px",
                      fontStyle: "italic",
                      fontSize: isMobileSmall ? "24px" : "20px",
                    }}
                  >
                    {t("steps.devices")}
                  </Typography>
                </Grid>
                <IconButton
                  sx={{
                    position: "absolute",
                    right: 0,
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "red",
                  }}
                >
                  <CloseIcon
                    sx={{
                      fontSize: "18px",
                    }}
                    onClick={toggleDrawer(false)}
                  />
                </IconButton>
              </Box>
              <Divider
                sx={{
                  height: "1px",
                  width: "100%",
                  backgroundColor: "#E9E9E9",
                  opacity: 1,
                  border: "none",
                }}
              />

              {deviceLoops?.map((item) => (
                <Grid key={item?.id}>
                  <Box
                    sx={{ display: "flex", width: "100%" }}
                    // onClick={() => changeDeviceNeeded(item?.type)}
                  >
                    <Grid
                      sx={{
                        width: "35%",
                        padding: "4px",
                        paddingLeft: item?.id === 3 ? "10px" : "20px",
                        marginTop: "10px",
                      }}
                    >
                      {/* <DirectionsCarIcon color="primary" /> */}
                      {/* {item?.icon} */}
                      <img
                        src={item?.image}
                        style={{ height: item?.id === 3 ? 62 : 85 }}
                      />
                    </Grid>
                    <Grid sx={{ width: "65%", padding: "4px" }}>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "16px",
                          marginTop: 1,
                        }}
                      >
                        {/* Ignition Interlock Device (IID) */}
                        {item?.title}
                      </Typography>
                      <Typography sx={{ fontSize: "14px", padding: "4px 0px" }}>
                        {item?.description}
                      </Typography>
                      <Grid
                        sx={{
                          textDecoration: "underline",
                          fontSize: "14px",
                          paddingTop: "6px",
                          paddingBottom: "8px",
                          color: "#4B9CD3",
                          fontWeight: "450",
                          textUnderlineOffset: "4px",
                        }}
                        onClick={() => changeDeviceNeeded(item?.type)}
                      >
                        {t("steps.chooseThisDevice")}
                      </Grid>
                    </Grid>
                  </Box>
                  <Grid
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Divider
                      sx={{
                        height: "3px",
                        width: "90%",
                        backgroundColor: "#E9E9E9",
                        opacity: 1,
                        border: "none",
                      }}
                    />
                  </Grid>
                </Grid>
              ))}
            </Box>
          </Drawer>
        </Grid>
      </form>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    statesList: state.statesList,
  };
}

const mapDispatchToProps = {
  loadStates,
  loadCountiesList,
  validateCode,
  clientProfiles,
  loadProgramTypes,
};

ViolationInfo.propTypes = {
  loadStates: PropTypes.func,
  loadCountiesList: PropTypes.func,
  statesList: PropTypes.object,
  validateCode: PropTypes.func,
  handleUpdate: PropTypes.func,
  goToBackStep: PropTypes.func,
  loadProgramTypes: PropTypes.func,
  submitting: PropTypes.bool,
  clientProfiles: PropTypes.func,
  setIsPam: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViolationInfo);
